{
  "shellSkipMenuMainContent": "주요 컨텐츠로 건너 뛰기"
}
